import classes from './budaErrorBox.scss';
import { getLocalizedStrings } from "../../../centralizedLocalizedString";
const BaErrorBox = (props) => {
    let strings = getLocalizedStrings("BaAlerts");
    let warningImg = drupalSettings.path.baseUrl + 'themes/custom/sce_responsive/images/Icon_Warning.svg';
    let reSubmit = (!props.uPreferenceError) ? <a href="javascript:void(0);" id="resubmit" onClick={props.onFormhandler}>{strings.reSubmit}</a> : null;
    let errMsg = props.uPreferenceError ?  strings.uPreferenceError : strings.errorMsg;
    const formErrorJSX = <div className={[classes.notificationLabel, classes.notificationLabelPadding].join(' ')}>
        <span>{strings.atleastOnePrefErrMsg}</span>
    </div>;
    const formResubmitJSX = <div className={classes.group2}>
        <div className={classes.notificationLabel}>
            <span>{errMsg}</span>
        </div>
        <div className={classes.somethingWrong}>
            {reSubmit}
        </div>
    </div>;
    let errormsg = props.turnOnButtonType ? formErrorJSX : formResubmitJSX;
    return (
        <div className={classes.errorBanner}>
            <div class="row">
                <div class="col-xs-12">
                    <div className={classes.errorMessageContainer}>
                        <div className={classes.errorMessage}>
                            <p className={classes.errorImage}><img src={warningImg} alt="Warning Image" /></p>
                            {errormsg}
                        </div>
                    </div>
                </div>
            </div>
            <br />
        </div>
    );
};
export default BaErrorBox;
